import { render, staticRenderFns } from "./ListaEspecialidades.vue?vue&type=template&id=fbae41de&scoped=true"
import script from "./ListaEspecialidades.vue?vue&type=script&lang=js"
export * from "./ListaEspecialidades.vue?vue&type=script&lang=js"
import style0 from "./ListaEspecialidades.vue?vue&type=style&index=0&id=fbae41de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbae41de",
  null
  
)

export default component.exports